<template>
  <tr>
    <td>{{ item.Name }}</td>
    <!-- 以下手機版不顯示 -->
    <td v-show="!isMobile">{{ item | projectFullIDFormat }}</td>
    <td v-show="!isMobile">{{ manager.Profile.Name }}</td>
    <td v-show="!isMobile">{{ clientName }}</td>
    <td v-show="!isMobile">{{ item.CreatedAt | dateFormat }}</td>
    <td v-show="!isMobile">
      <span
        v-if="(item.Status == '執行中' || item.Status == '已結案' || item.Status == '已完成') && item.FinalAmount > 0"
        class="green--text"
      >
        {{item.FinalAmount | amountFormat}}
      </span>
      <span
        v-else
        class="red--text"
      >
        {{item.Amount | amountFormat}}
      </span>
    </td>
    <!-- 以上手機版不顯示 -->
    <td>{{ item.Status }}</td>
    <td>
      <v-icon
        class="ml-1 mr-1"
        @click.stop="viewItem"
      >mdi-eye</v-icon>
      <v-btn
        class="ml-1 mr-1"
        color="white"
        text
        small
        @click.stop="viewGantt"
      >甘特圖</v-btn>
      <v-icon
        v-if="canEditProject"
        class="ml-1 mr-1"
        @click.stop="editItem"
      >edit</v-icon>

      <v-tooltip
        top
        v-if="canEditProject"
      >
        <template v-slot:activator="{ on }">
          <span
            v-on="on">
            <v-icon
              :disabled="!canDeleteThisProject"
              class="ml-1 mr-1"
              @click.stop="confirmDeleteItem"
            >delete</v-icon>
          </span>
        </template>
        <span v-if="!canDeleteThisProject">無法刪除，日誌已審核獎金</span>
        <span v-else>刪除專案</span>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import redirectMixin from "@/ui/mixin-redirect.vue";
import filterMixin from "@/data/filters/filter-mixin.vue";
export default {
  mixins: [filterMixin, redirectMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    manager() {
      return this.users.find(o => o.ID == this.item.ManagerID) || {Profile:{}};
    },
    clientName() {
      let client =
        this.$store.state.client.list.find(o => o.ID === this.item.ClientID) ||
        {};
      let clientCounty =
        this.$store.state.county.list.find(o => o.ID === client.CountyID) || {};
      return (clientCounty.Name || "") + (client.Name || "");
    },
    canDeleteThisProject() {
      return this.item.Deletable
      /* 2021/1/15 v1.4.20 過於lag，v1.4.21 加入了「Deletable」
      // 找到已經審核的taskWorkingItem
      const findTaskWorkingItemTask = o =>
        this.tasks.find(task => task.ID == o.TaskID) || {};
      return (
        this.taskWorkingItems
          .filter(o => findTaskWorkingItemTask(o).ProjectID == this.item.ID)
          .findIndex(o => o.Status == "獎金發放中" || o.Status == "已完成") < 0
      );*/
    },
    ...mapGetters(["canEditProject", "taskWorkingItems", "tasks", "users"])
  },
  methods: {
    viewItem() {
      this.redirectToProject(this.item.ID);
    },
    viewGantt() {
      this.$store.state.UI.dialog.projectGantt.id = this.item.ID;
      this.$store.state.UI.dialog.projectGantt.isShow = true;
    },
    editItem() {
      // this.$router.push({
      //   name: "project-editor",
      //   params: { id: this.item.ID }
      // });
      this.$store.state.UI.dialog.projectEditor.id = this.item.ID;
      this.$store.state.UI.dialog.projectEditor.isShow = true;
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除「" + (this.item.Name || "") + "」?")) return;
      this.$emit("remove", this.item);
    }
  }
};
</script>